import formatTimestamp from '@app/utils/time-formatter'
import datetimeToMoment from '@app/utils/time-converter'
import { isCurrentDate } from '@app/utils/date-formatter'

const formatDatetime = (
  datetime,
  shouldUseLocalTimezone,
  format,
  shouldUseRelativeFormatOnCurrentDate,
  shouldAlwaysShowTooltip,
  tooltipFormat
) => {
  const formattedMoment = formatTimestamp(datetime, {
    shouldUseLocalTimezone,
    format,
    shouldUseRelativeFormatOnCurrentDate,
  })

  if (shouldUseRelativeFormatOnCurrentDate) {
    const originalMoment = datetimeToMoment(datetime, shouldUseLocalTimezone)

    if (isCurrentDate(originalMoment) || shouldAlwaysShowTooltip) {
      const tooltipMoment = formatTimestamp(datetime, {
        shouldUseLocalTimezone,
        tooltipFormat,
        shouldUseRelativeFormatOnCurrentDate: false,
      })

      return `<span data-toggle='tooltip' data-placement='bottom' data-html='true' title='${tooltipMoment}'>${formattedMoment}</span>`
    }
  }

  return formattedMoment
}

export default (context) => {
  const timestampElements = context.querySelectorAll(
    "[data-behaviour='formatted-timestamp']"
  )

  timestampElements.forEach((element) => {
    const datetime =
      element.dataset.datetime || element.getAttribute('datetime')
    const shouldUseLocalTimezone = element.dataset.useLocalTimezone || false
    const format = element.dataset.format || 'D MMMM Y, HH:mm z'
    const shouldUseRelativeFormatOnCurrentDate =
      element.dataset.useRelativeFormatOnCurrentDate || false
    const shouldAlwaysShowTooltip = element.dataset.alwaysShowTooltip || false
    const tooltipFormat = element.dataset.tooltipFormat || format

    const formattedMoment = formatDatetime(
      datetime,
      shouldUseLocalTimezone,
      format,
      shouldUseRelativeFormatOnCurrentDate,
      shouldAlwaysShowTooltip,
      tooltipFormat
    )

    if (formattedMoment) {
      element.innerHTML = ''
      element.insertAdjacentHTML('afterbegin', formattedMoment)
    }
  })
}
